import React from 'react'
import { isWorldCup2026League } from '../constants/worldCup2026TeamFlags'
import TeamNameWithFlag from './TeamNameWithFlag'

interface MatchTeamsInlineProps {
  teamA: string
  teamB: string
  league?: string | null
  separator?: string
  className?: string
  nameClassName?: string
  flagClassName?: string
}

const MatchTeamsInline: React.FC<MatchTeamsInlineProps> = ({
  teamA,
  teamB,
  league,
  separator = '–',
  className = '',
  nameClassName = '',
  flagClassName = 'text-sm leading-none flex-shrink-0',
}) => {
  if (!isWorldCup2026League(league)) {
    return (
      <span className={className}>
        {teamA} {separator} {teamB}
      </span>
    )
  }

  return (
    <span className={`inline-flex flex-wrap items-center justify-center gap-x-1.5 gap-y-0.5 ${className}`}>
      <TeamNameWithFlag
        teamName={teamA}
        league={league}
        side="home"
        nameClassName={nameClassName}
        flagClassName={flagClassName}
      />
      <span className="text-muted-foreground/80" aria-hidden>
        {separator}
      </span>
      <TeamNameWithFlag
        teamName={teamB}
        league={league}
        side="away"
        nameClassName={nameClassName}
        flagClassName={flagClassName}
      />
    </span>
  )
}

export default MatchTeamsInline
